var _path, _polygon, _g, _g2, _path2, _g3, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63.181mm",
    height: "88.137mm",
    viewBox: "0 0 63.181 88.137",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86.17 -109.1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m108.71 128.78a16.828 16.828 0 0 1-1.85 0.58505c-0.82876 0.20198-1.2967 0.2956-2.0966-0.0149-0.0282-0.011-0.0549-0.0217-0.0802-0.0323a8.4972 8.4972 0 0 1-5.1716-7.7047c-0.0043-0.0565-0.0043-0.11593-0.0043-0.17388a8.2782 8.2782 0 0 1 0.03998-0.83611 8.4517 8.4517 0 0 1 0.18122-1.1245l-0.0078-2e-3c-0.64762-0.66222-0.8968-1.5693-0.81418-2.4808a4.1003 4.1003 0 0 1 1.8522-3.0662 6.4868 6.4868 0 0 1 2.6931-0.95058 6.8248 6.8248 0 0 1 0.77421-0.0449h2.4306a10.501 10.501 0 0 1 1.5258-0.24055h3e-3c4.8918-0.40574 8.7495 2.8373 8.3897 6.7831-3e-3 4e-3 -7e-3 9e-3 -9e-3 0.013-0.10394 0.16954-0.19588 0.33039-0.27717 0.48398-0.0787 0.14346-0.14525 0.28112-0.20255 0.41154-0.4464 1.0086 1.675 16.656 0.91412 16.894-0.43308 0.13476-2.1787-11.509-1.8656-9.2949 0.39445 2.7778-4.1721-0.0379-6.4258 0.79522z",
    fill: "#2f2e41",
    strokeWidth: 0.14732
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.14732 0 0 .14732 86.023 98.779)",
    points: "73.005 475.78 109.97 381.64 204.04 395.65 250.07 493.71",
    fill: "#ffb6b6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.14732
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.69 186.03a37.995 37.995 0 0 1-14.09 1.8872l-2.0757-3.3663s-0.0869 1.2537-0.21656 3.1703a36.656 36.656 0 0 1-6.6986-1.4202c-4.1412-1.2949-8.023-3.3014-11.958-5.1518-0.797-4.751-1.0961-12.077 3.3103-16.342l23.717 4.3459s3.8053 2.8462 2.7873 3.8657c-1.018 1.018-1.1756 0.86034-0.50679 1.5292 0.66883 0.66883 2.114 1.5631 2.1288 2.1479 6e-3 0.22834 1.6279 4.3695 3.602 9.3342z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.94 129.15-5.73 0.39977-3.7035 3.5787-1.297 0.23151a4.8357 4.8357 0 0 0-3.9785 5.045c0.2668 4.5202 0.86415 11.274 2.1127 13.465 1.936 3.3977 3.535 2.3316 1.936 3.3977-1.5991 1.066-2.6726 0.22836-1.936 1.9131 0.73666 1.6848-0.99564 3.8457-0.99564 3.8457l-0.68961 0.68961 0.73141 0.29976 23.305 3.0325s-2.0151-9.0604-0.75489-11.286c1.2602-2.2257 4.3159-8.9536 1.5888-11.586l-2.6665-9.3834-4.5866-1.3527z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.63 166.34a2.649 2.649 0 0 1-2.5163-3.1534l-10.932-7.4036 1.3044-3.5273 12.92 8.8883a2.6453 2.6453 0 0 1-0.77596 5.196z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.75 132.35-1.5886 0.629 8.4741 16.55 17.543 11.958 2.5287-4.2739-13.354-11.534-5.3462-10.253a6.5801 6.5801 0 0 0-8.2571-3.0757z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.78,
    cy: 121.94,
    r: 5.7537,
    fill: "#ffb6b6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2f2e41",
    strokeWidth: 0.14732
  }, /*#__PURE__*/React.createElement("path", {
    d: "m113.78 119.51c-0.0959 0.0506-0.19056 0.0973-0.2865 0.14391-0.0999 0.048-0.19988 0.096-0.30115 0.14125-1.9255 0.87282-3.494 0.97011-4.4454-0.28516a5.3284 5.3284 0 0 0-0.4384-1.9162 3.0794 3.0794 0 0 1-0.5077 1.9162h-1.9162c-1.9735 1.3099-2.9862 2.5132-1.6164 6.8133 0.0893 0.28251 0.70091 10.319 0.87547 11.091-2.9876-1.146-5.5647-13.313-5.63-16.52-0.0043-0.052-0.0043-0.10659-0.0043-0.15991a7.0056 7.0056 0 0 1 0.03998-0.76886 7.1982 7.1982 0 0 1 0.18122-1.0341l-0.0078-2e-3a2.7005 2.7005 0 0 1-0.81418-2.2813 6.5798 6.5798 0 0 1 1.8283-1.639 11.667 11.667 0 0 1 2.0015-0.75156c0.0173-4e-3 0.032-8e-3 0.0493-0.012 0.21054-0.0573 0.42641-0.10927 0.64228-0.15458a12.061 12.061 0 0 1 1.3472-0.20388c0.0333-8.7e-4 0.0653-4e-3 0.0946-4e-3a1.0096 1.0096 0 0 1 0.51436 0.14125c8.7e-4 0 8.7e-4 2e-3 4e-3 2e-3a1.015 1.015 0 0 1 0.49437 0.86349h2.1348c0.0787 0 0.15724 3e-3 0.23586 7e-3 2.9729 0.1186 5.3622 1.3899 5.5154 4.3121 7e-3 0.10127 9e-3 0.19989 9e-3 0.30116z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.16,
    cy: 115.95,
    r: 3.7906
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.36 114.2c-0.43063 2.0487-2.5553 3.274-4.5879 2.7728a3.7906 3.7906 0 0 1-2.7728-4.5879c0.50122-2.0326 2.968-1.4466 4.5879-2.7728 2.2915-1.876 3.3535 1.825 2.7728 4.5879z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m97.942 171.22c3.2306-13.174 9.6318-24.498 20.233-33.37a2.9826 2.9826 0 0 1 4.0921-1.0029l25.202 15.28a2.9826 2.9826 0 0 1 1.0029 4.0921c-4.0463 13.518-10.107 25.249-20.233 33.37a2.9825 2.9825 0 0 1-4.0921 1.0029l-25.202-15.28a2.9826 2.9826 0 0 1-1.0029-4.0921z",
    fill: "#f2f2f2",
    strokeWidth: 0.14732
  })), /*#__PURE__*/React.createElement("path", {
    d: "m102.42 175.66a2.9826 2.9826 0 0 1-1.0029-4.0921c3.2306-13.174 9.6318-24.498 20.233-33.37a2.9441 2.9441 0 0 1 1.1116-1.05l-0.49592-0.30071a2.9827 2.9827 0 0 0-4.0921 1.0028c-10.601 8.872-17.002 20.196-20.233 33.37a2.9825 2.9825 0 0 0 1.0029 4.0921l25.202 15.28a2.9693 2.9693 0 0 0 2.9805 0.0472z",
    opacity: 0.2,
    strokeWidth: 0.14732,
    style: {
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 0.14732
  }, /*#__PURE__*/React.createElement("path", {
    d: "m131.98 168.3-16.917-10.193a1.185 1.185 0 0 1 1.2231-2.03l16.917 10.193a1.185 1.185 0 0 1-1.2232 2.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.14 154.79-3.7216-2.2424a1.185 1.185 0 0 1 1.2167-2.0339l7e-3 3e-3 3.7216 2.2424a1.185 1.185 0 0 1-1.2232 2.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.29 172.77-16.917-10.193a1.185 1.185 0 0 1 1.2207-2.0315l3e-3 2e-3 16.917 10.193a1.185 1.185 0 0 1-1.2232 2.03z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.14732
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.12,
    cy: 144.14,
    r: 4.941,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.61,
    cy: 186.53,
    r: 10.561,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.61 197.24a10.708 10.708 0 1 1 10.708-10.708 10.72 10.72 0 0 1-10.708 10.708zm0-21.121a10.413 10.413 0 1 0 10.413 10.413 10.425 10.425 0 0 0-10.413-10.413z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.17 192.02a1.1744 1.1744 0 0 1-0.93968-0.46999l-2.8811-3.8415a1.1747 1.1747 0 1 1 1.8796-1.4096l1.8849 2.513 4.8412-7.2616a1.1747 1.1747 0 1 1 1.9549 1.3033l-5.7622 8.6433a1.1752 1.1752 0 0 1-0.94485 0.52276c-0.0109 1.4e-4 -0.0217 4.4e-4 -0.0327 4.4e-4z",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.513 171.36a2.8097 2.8097 0 0 1-1.3311-4.0669l-8.1181-11.412 2.6043-3.0215 9.5429 13.624a2.8058 2.8058 0 0 1-2.6981 4.8758z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.7 135.2a2.0035 2.0035 0 0 0-2.5607 0.45081l-10.969 15.34 10.165 14.437 3.9776-4.2723-6.1874-9.7231 8.2231-7.8294a6.5801 6.5801 0 0 0-2.6491-8.4036z",
    fill: "#ffc107"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.ad3e76d52e410f1cdc1132a91ea2b732.svg";
export { ForwardRef as ReactComponent };